import styles from './OrganizationDefaultUsers.module.scss';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Card, CardContent, CardHeader } from '@mui/material';
import { DefaultUser } from 'types';
import { DefaultUserCheckbox } from './DefaultUserCheckbox/DefaultUserCheckbox';

export interface OrganizationDefaultUsersProps {
    supplierId: string;
    supplierDefaultUsers: DefaultUser[];
    updateDefaultUsers: React.Dispatch<React.SetStateAction<DefaultUser[]>>;
}

export const OrganizationDefaultUsers = ({
    supplierId,
    supplierDefaultUsers,
    updateDefaultUsers,
}: OrganizationDefaultUsersProps) => {
    const onDefaultUserUpdate = (updatedDefaultUser: DefaultUser): void => {
        const updatedDefaultUsers = supplierDefaultUsers.map(
            (user: DefaultUser) => {
                if (user.uid === updatedDefaultUser.uid) {
                    user.issue = updatedDefaultUser.issue;
                    user.threshold = updatedDefaultUser.threshold;
                    user.offline = updatedDefaultUser.offline;
                }
                return user;
            }
        );
        updateDefaultUsers(updatedDefaultUsers);
    };

    const columns: GridColDef[] = [
        {
            field: 'email',
            headerName: 'Email',
            flex: 2,
            valueGetter: (param) => param.row.email ?? '-',
            sortingOrder: ['asc', 'desc'],
        },
        {
            field: 'threshold',
            headerName: 'Tank Level',
            renderCell: (params) => (
                <DefaultUserCheckbox
                    params={params}
                    field="threshold"
                    supplierId={supplierId}
                    onDefaultUserUpdate={onDefaultUserUpdate}
                />
            ),
        },
        {
            field: 'offline',
            headerName: 'Offline',
            renderCell: (params) => (
                <DefaultUserCheckbox
                    params={params}
                    field="offline"
                    supplierId={supplierId}
                    onDefaultUserUpdate={onDefaultUserUpdate}
                />
            ),
        },
        {
            field: 'issue',
            headerName: 'Issues',
            renderCell: (params) => (
                <DefaultUserCheckbox
                    params={params}
                    field="issue"
                    supplierId={supplierId}
                    onDefaultUserUpdate={onDefaultUserUpdate}
                />
            ),
        },
    ];

    return (
        <div
            data-testid="OrganizationDefaultUsers"
            className={styles.OrganizationDefaultUsers}
        >
            <Card className={styles.card}>
                <CardHeader title="Default Users" />
                <CardContent>
                    <DataGrid
                        autoHeight
                        columns={columns}
                        rows={supplierDefaultUsers}
                        getRowId={(user) => user.uid}
                        disableSelectionOnClick
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'name', sort: 'asc' }],
                            },
                        }}
                        disableColumnMenu
                    />
                </CardContent>
            </Card>
        </div>
    );
};
